import ThermalPrinterEncoder, {
  ThermalPrinterEncoderOption,
} from "../../lib/thermal-printer-encoder"

export type DeliveryOrderDetails = {
  customerName: string
  customerAddress: string
  customerPhone: string
  deliveryDate: string
  businessName: string
  businessAddress: string
  businessPhone: string
  businessEmail: string
  businessLocationName: string
  orderNumber: string
  doNumber: string
  deliveryFee: number
  otherFees: number
  items: {
    name: string
    quantity: number
  }[]
}

export const encodeDeliveryOrder = async (
  deliveryOrder: DeliveryOrderDetails,
  encoderOptions: ThermalPrinterEncoderOption = {
    language: "esc-pos",
    columns: 32,
    feedBeforeCut: 1,
  }
) => {
  const width = encoderOptions.columns || 32
  let encoder = new ThermalPrinterEncoder({
    ...encoderOptions,
    imageMode: "raster",
  }).initializeWithMultiByte()

  const {
    customerName,
    customerAddress,
    customerPhone,
    deliveryDate,
    businessName,
    businessAddress,
    businessPhone,
    businessEmail,
    businessLocationName,
    orderNumber,
    doNumber,
    deliveryFee,
    otherFees,
    items,
  } = deliveryOrder

  //add a line
  encoder = encoder.newline()

  //business name
  encoder = encoder
    .align("left")
    .bold(true)
    .line(businessName)
    .bold(false)
    .newline()

  //Business address, phone, email
  encoder = encoder
    .align("left")
    .line(businessAddress)
    .line(businessPhone)
    .line(businessEmail)
    .newline()

  //title
  encoder = encoder
    .align("left")
    .bold(true)
    .line("Delivery Order")
    .bold(false)
    .newline()

  //do number, order number, store location, delivery date, ship to, address, delivery fee, other fees
  encoder = encoder
    .align("left")
    .line(`DO No: ${doNumber}`)
    .line(`Order No: ${orderNumber}`)
    .line(`Store: ${businessLocationName}`)
    .line(`Delivery Date: ${deliveryDate}`)
    .line(`Ship To: ${customerName}`)
    .line(`Phone: ${customerPhone}`)
    .line(`Address: ${customerAddress}`)
    .line(`Total Fee: ${deliveryFee.toFixed(2)}`)
    .line(`Other Fees: ${otherFees.toFixed(2)}`)
    .newline()

  //table with items
  let rows: Array<[string, string]> = [["Item", "Qty"]]
  items?.forEach((t) => {
    rows.push([t.name, t.quantity.toString()])
  })

  encoder = encoder.table(
    [
      { width: 20 - 1, marginRight: 2, align: "left" },
      { width: width - 20 - 1, align: "right" },
    ],
    rows
  )

  //empty signature line for driver name
  encoder = encoder
    .align("left")
    .newline()
    .line("Driver Name:")
    .newline()
    .line("____________________")
    .newline()
    .newline()

  //empty signature line for date
  encoder = encoder
    .line("Date:")
    .newline()
    .line("____________________")
    .newline()
    .newline()

  //empty signature line for customer signature
  encoder = encoder
    .line("Customer Signature:")
    .newline()
    .line("____________________")
    .newline()
    .newline()

  //Thank you for your order. Please verify items and quantities before signing.
  encoder = encoder
    .align("center")
    .newline()
    .line("Thank you for your order.")
    .line("Please verify items and quantities before signing.")
    .newline()

  return encoder.newline().cut().encode()
}
